import { ApplicationConfig, Injectable, effect, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PreloadAllModules, RouterStateSnapshot, TitleStrategy, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { I18n } from './core/i18n/i18n.service';
import { Dict } from './core/i18n/en';

/** Route titles are keys into the dictionary's `titles`, re-set when the language changes. */
@Injectable()
class TranslatedTitles extends TitleStrategy {
  private i18n = inject(I18n);
  private title = inject(Title);
  private key: keyof Dict['titles'] = 'home';

  constructor() {
    super();
    effect(() => this.title.setTitle(this.i18n.t().titles[this.key]));
  }

  override updateTitle(state: RouterStateSnapshot): void {
    this.key = (this.buildTitle(state) as keyof Dict['titles']) || 'home';
    this.title.setTitle(this.i18n.t().titles[this.key] || this.i18n.t().titles.home);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      // Every page is fetched in the background after the first, so moving between them never waits.
      withPreloading(PreloadAllModules),
    ),
    { provide: TitleStrategy, useClass: TranslatedTitles },
    provideAppInitializer(() => inject(I18n).init()),
  ],
};
